export const primary50 = "#fafcff"; // Primary 50
export const primary100 = "#e6f1fe"; // Primary 100
export const primary200 = "#b9d9fa"; // Primary 200
export const primary300 = "#90c0f4"; // Primary 300
export const primary400 = "#69a8eb"; // Primary 400
export const primary500 = "#448fdf"; // Primary 500
export const primary600 = "#2277d1"; // Primary 600
export const primary700 = "#1b5fa7"; // Primary 700
export const primary800 = "#14477d"; // Primary 800
export const primary900 = "#0e3054"; // Primary 900
export const primaryBase = "#2277d1"; // Primary
export const secondary100 = "#f9faff"; // [Deprecated] Secondary 100
export const secondary200 = "#d0d4e1"; // [Deprecated] Secondary 200
export const secondary300 = "#9ea3b7"; // [Deprecated] Secondary 300
export const secondary400 = "#6e7694"; // [Deprecated] Secondary 400
export const secondary500 = "#3d4870"; // [Deprecated] Secondary 500
export const secondary600 = "#0d1a4c"; // [Deprecated] Secondary 600
export const secondary700 = "#0a1439"; // [Deprecated] Secondary 700
export const secondary800 = "#070d26"; // [Deprecated] Secondary 800
export const secondary900 = "#030511"; // [Deprecated] Secondary 900
export const secondaryBase = "#0d1a4c"; // [Deprecated] Secondary
export const neutral0 = "#ffffff"; // Neutral 0
export const neutral50 = "#fbfbfb"; // Neutral 50
export const neutral100 = "#f5f5f5"; // Neutral 100
export const neutral200 = "#e9e9e9"; // Neutral 200
export const neutral300 = "#d5d5d5"; // Neutral 300
export const neutral400 = "#bcbcbc"; // Neutral 400
export const neutral500 = "#a7a7a7"; // Neutral 500
export const neutral550 = "#949494"; // Neutral 550
export const neutral600 = "#767676"; // Neutral 600
export const neutral700 = "#333333"; // Neutral 700
export const neutral800 = "#030303"; // Neutral 800
export const neutral900 = "#030303"; // Neutral 900
export const neutralBackground = "#ffffff"; // Background
export const neutralBackgroundDark = "#f5f5f5"; // Background Dark
export const neutralDisabled = "#949494"; // Disabled
export const neutralText = "#030303"; // Text
export const neutralTextLight = "#767676"; // Text Light
export const success50 = "#f6faf5"; // Success 50
export const success100 = "#e7f4e6"; // Success 100
export const success200 = "#b2d9ac"; // Success 200
export const success300 = "#7ebc73"; // Success 300
export const success400 = "#4c9c3c"; // Success 400
export const success500 = "#1c7a09"; // Success 500
export const success600 = "#186808"; // Success 600
export const success700 = "#145506"; // Success 700
export const success800 = "#0f4305"; // Success 800
export const success900 = "#0b3104"; // Success 900
export const successBase = "#1c7a09"; // Success
export const warning50 = "#fef9ee"; // Warning 50
export const warning100 = "#fff3d9"; // Warning 100
export const warning200 = "#ffe4ac"; // Warning 200
export const warning300 = "#ffcf73"; // Warning 300
export const warning400 = "#ffb939"; // Warning 400
export const warning500 = "#ffa100"; // Warning 500
export const warning600 = "#d98900"; // Warning 600
export const warning700 = "#b37100"; // Warning 700
export const warning800 = "#8c5900"; // Warning 800
export const warning900 = "#664000"; // Warning 900
export const warningBase = "#ffa100"; // Warning
export const danger50 = "#fdf8f8"; // Danger 50
export const danger100 = "#fbe6e6"; // Danger 100
export const danger200 = "#eeacb1"; // Danger 200
export const danger300 = "#df767e"; // Danger 300
export const danger400 = "#cb444f"; // Danger 400
export const danger500 = "#b41522"; // Danger 500
export const danger600 = "#99121d"; // Danger 600
export const danger700 = "#7e0f18"; // Danger 700
export const danger800 = "#630c13"; // Danger 800
export const danger900 = "#48080e"; // Danger 900
export const dangerBase = "#b41522"; // Danger
export const brandNavy100 = "#e6ecf5"; // [Brand] Navy 100
export const brandNavy200 = "#acc0db"; // [Brand] Navy 200
export const brandNavy300 = "#7395be"; // [Brand] Navy 300
export const brandNavy400 = "#39699f"; // [Brand] Navy 400
export const brandNavy500 = "#003e7d"; // [Brand] Navy 500
export const brandNavy600 = "#00396a"; // [Brand] Navy 600
export const brandNavy700 = "#003257"; // [Brand] Navy 700
export const brandNavy800 = "#002a45"; // [Brand] Navy 800
export const brandNavy900 = "#002032"; // [Brand] Navy 900
export const brandGreen100 = "#e6f3ed"; // [Brand] Green 100
export const brandGreen200 = "#afd8c4"; // [Brand] Green 200
export const brandGreen300 = "#7bba9c"; // [Brand] Green 300
export const brandGreen400 = "#489a73"; // [Brand] Green 400
export const brandGreen500 = "#18784a"; // [Brand] Green 500
export const brandGreen600 = "#15663c"; // [Brand] Green 600
export const brandGreen700 = "#11542f"; // [Brand] Green 700
export const brandGreen800 = "#0d4223"; // [Brand] Green 800
export const brandGreen900 = "#0a3018"; // [Brand] Green 900
export const brandBrown100 = "#ece8e6"; // [Brand] Brown 100
export const brandBrown200 = "#c1b5ac"; // [Brand] Brown 200
export const brandBrown300 = "#948275"; // [Brand] Brown 300
export const brandBrown400 = "#674f3e"; // [Brand] Brown 400
export const brandBrown500 = "#381c08"; // [Brand] Brown 500
export const brandBrown600 = "#301607"; // [Brand] Brown 600
export const brandBrown700 = "#271106"; // [Brand] Brown 700
export const brandBrown800 = "#1f0d05"; // [Brand] Brown 800
export const brandBrown900 = "#160803"; // [Brand] Brown 900
export const brandRed100 = "#f7e6ea"; // [Brand] Red 100
export const brandRed200 = "#e2adba"; // [Brand] Red 200
export const brandRed300 = "#cb778c"; // [Brand] Red 300
export const brandRed400 = "#b14560"; // [Brand] Red 400
export const brandRed500 = "#941535"; // [Brand] Red 500
export const brandRed600 = "#7e1231"; // [Brand] Red 600
export const brandRed700 = "#670f2c"; // [Brand] Red 700
export const brandRed800 = "#510c25"; // [Brand] Red 800
export const brandRed900 = "#3b091d"; // [Brand] Red 900
export const brandTan100 = "#fffcf7"; // [Brand] Tan 100
export const brandTan200 = "#fdf6e7"; // [Brand] Tan 200
export const brandTan300 = "#fbefd8"; // [Brand] Tan 300
export const brandTan400 = "#f7e8ca"; // [Brand] Tan 400
export const brandTan500 = "#f2e0bd"; // [Brand] Tan 500
export const brandTan600 = "#cebda1"; // [Brand] Tan 600
export const brandTan700 = "#a99a84"; // [Brand] Tan 700
export const brandTan800 = "#857868"; // [Brand] Tan 800
export const brandTan900 = "#61564c"; // [Brand] Tan 900
export const brandOrange100 = "#ffeee6"; // [Brand] Orange 100
export const brandOrange200 = "#ffc9ac"; // [Brand] Orange 200
export const brandOrange300 = "#ffa575"; // [Brand] Orange 300
export const brandOrange400 = "#ff8345"; // [Brand] Orange 500
export const brandOrange500 = "#f5631a"; // [Brand] Orange 500
export const brandOrange600 = "#d04d16"; // [Brand] Orange 600
export const brandOrange700 = "#ab3a13"; // [Brand] Orange 700
export const brandOrange800 = "#86290f"; // [Brand] Orange 800
export const brandOrange900 = "#621b0b"; // [Brand] Orange 900
export const brandYellow100 = "#fffbe8"; // [Brand] Yellow 100
export const brandYellow200 = "#fff2b6"; // [Brand] Yellow 200
export const brandYellow300 = "#ffe689"; // [Brand] Yellow 300
export const brandYellow400 = "#ffd960"; // [Brand] Yellow 400
export const brandYellow500 = "#fcc93c"; // [Brand] Yellow 500
export const brandYellow600 = "#d6a533"; // [Brand] Yellow 600
export const brandYellow700 = "#b0832a"; // [Brand] Yellow 700
export const brandYellow800 = "#8a6321"; // [Brand] Yellow 800
export const brandYellow900 = "#644518"; // [Brand] Yellow 900
export const brandPurple100 = "#f0ecf5"; // [Brand] Purple 100
export const brandPurple200 = "#d5cce3"; // [Brand] Purple 200
export const brandPurple300 = "#baacd0"; // [Brand] Purple 300
export const brandPurple400 = "#9f8dbc"; // [Brand] Purple 400
export const brandPurple500 = "#846fa7"; // [Brand] Purple 500
export const brandPurple600 = "#6a5291"; // [Brand] Purple 600
export const brandPurple700 = "#554274"; // [Brand] Purple 700
export const brandPurple800 = "#403157"; // [Brand] Purple 800
export const brandPurple900 = "#2a213a"; // [Brand] Purple 900
export const lightAlpha50 = "rgba(255, 255, 255, 0.04)"; // Translucent Neutral Light 50
export const lightAlpha100 = "rgba(255, 255, 255, 0.06)"; // Translucent Neutral Light 100
export const lightAlpha200 = "rgba(255, 255, 255, 0.08)"; // Translucent Neutral Light 200
export const lightAlpha300 = "rgba(255, 255, 255, 0.16)"; // Translucent Neutral Light 300
export const lightAlpha400 = "rgba(255, 255, 255, 0.24)"; // Translucent Neutral Light 400
export const lightAlpha500 = "rgba(255, 255, 255, 0.36)"; // Translucent Neutral Light 500
export const lightAlpha600 = "rgba(255, 255, 255, 0.48)"; // Translucent Neutral Light 600
export const lightAlpha700 = "rgba(255, 255, 255, 0.64)"; // Translucent Neutral Light 700
export const lightAlpha800 = "rgba(255, 255, 255, 0.8)"; // Translucent Neutral Light 800
export const lightAlpha900 = "rgba(255, 255, 255, 0.92)"; // Translucent Neutral Light 900
export const darkAlpha50 = "rgba(0, 0, 0, 0.04)"; // Translucent Neutral Dark 50
export const darkAlpha100 = "rgba(0, 0, 0, 0.06)"; // Translucent Neutral Dark 100
export const darkAlpha200 = "rgba(0, 0, 0, 0.08)"; // Translucent Neutral Dark 200
export const darkAlpha300 = "rgba(0, 0, 0, 0.16)"; // Translucent Neutral Dark 300
export const darkAlpha400 = "rgba(0, 0, 0, 0.24)"; // Translucent Neutral Dark 400
export const darkAlpha500 = "rgba(0, 0, 0, 0.36)"; // Translucent Neutral Dark 500
export const darkAlpha600 = "rgba(0, 0, 0, 0.48)"; // Translucent Neutral Dark 600
export const darkAlpha700 = "rgba(0, 0, 0, 0.64)"; // Translucent Neutral Dark 700
export const darkAlpha800 = "rgba(0, 0, 0, 0.8)"; // Translucent Neutral Dark 800
export const darkAlpha900 = "rgba(0, 0, 0, 0.92)"; // Translucent Neutral Dark 900
export const overlayLight = "rgba(255, 255, 255, 0.48)"; // Translucent Overlay Light
export const overlayDark = "rgba(0, 0, 0, 0.48)"; // Translucent Overlay Light
export const background = "#ffffff"; // Background
export const foreground = "#030303"; // Foreground
export const haloPrimary = "rgba(34,119,209,0.3)"; // Halo Primary
export const haloNeutral = "rgba(118,118,118,0.3)"; // Halo Neutral
export const haloDanger = "rgba(180,21,34,0.3)"; // Halo Danger
export const haloWarning = "rgba(255,161,0,0.3)"; // Halo Warning
export const haloSuccess = "rgba(28,122,9,0.3)"; // Halo Success
export const ringPrimary = "rgba(34,119,209,0.3)"; // Ring Primary
export const ringNeutral = "rgba(118,118,118,0.2)"; // Ring Neutral
export const borderDanger = "#b41522";
export const borderDisabled = "#d5d5d5";
export const borderFocus = "#1b5fa7";
export const borderFocusDanger = "#99121d";
export const borderFocusNeutral = "#333333";
export const borderFocusSuccess = "#186808";
export const borderFocusWarning = "#d98900";
export const borderIdle = "#767676";
export const borderInvalid = "#b41522";
export const borderInvalidFocus = "#99121d";
export const borderNeutral = "#767676";
export const borderPrimary = "#2277d1";